import { Link } from 'gatsby'
import Layout from '../layouts/layout'
import React from 'react'
import SEO from '../components/seo'
import headerImage from '../images/about-us-header.jpg'
import melissa from '../images/melissa-strong.jpg'

const PageContent = props => (
  <Layout location={props.location}>
    <SEO title="About Us" keywords={[`gatsby`, `application`, `react`]} />
    <div className="container py-5">
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1">
          <h1 id="headerImage1" className="headerImage py-5 mb-5">Meet Simple Summers</h1>
          <div className="container">
            <div className="row flex-md-row">
              <div className="col-md-7">
                <p>In 2018, Meghan Phillips, DJ Waldow, and a fellow Sacramento area parent set out to fix something that frustrated them every spring: finding summer camps. Getting it right — the right fit for their kids, their budget, their schedule — was harder than it should have been. The same exhausting cycle year after year: Google searches that went nowhere, spreadsheets that never felt complete.</p>
                <p>So they built Simple Summers: a searchable, filterable directory of summer camps in the Sacramento area, designed to do the hard work so parents didn't have to.</p>
                <p>Over the next several years, it grew into the go-to resource for Sacramento area families — hundreds of camps, thousands of sessions, and a community of parents who came to rely on it.</p>
                <p>I'm one of those parents.</p>
                <p>My name is Melissa Strong, and I took over Simple Summers in 2026. This platform made summers better for my family, and I'm here to do the same for yours.</p>
                <p>Today, Simple Summers is growing, connecting our community of camps and families, and hopefully helping lives thrive!</p>
                <p>Please reach out if you have opportunities for our community!</p>
                <p>Smile. It's simple.</p>
                <p>– Melissa</p>
                <p>Questions/comments: Email us at <a href="mailto:hello@simplesummers.com">hello@simplesummers.com</a></p>
              </div>
              <div className="col-md-5">
                <img src={ melissa } className="rounded img-fluid shadow-sm" alt="Melissa Strong" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default PageContent
